import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_PLANS_SELECTION:
      return state.withMutations((mutateState) => mutateState
        .set('selection', fromJS(action.payload.data))
        .set('processingLocalized', action.payload.processing))
    case actions.SET_PLANS_SELECTION_ELIGIBILITY: {
      const selection = state.get('selection')
      if (!Map.isMap(selection) || selection.isEmpty()) {
        return state
      }
      const { sku, eligibility } = action.payload
      if (!sku || selection.get('sku') !== sku) {
        return state
      }
      return state.setIn(['selection', 'eligibility'], fromJS(eligibility))
    }
    case actions.DELETE_PLANS_SELECTION:
      return state.delete('selection')
    case actions.SET_PLAN_CHANGE_SELECTED:
      return state.setIn(['changePlanData', 'selectedPlan'], fromJS(action.payload))
    default:
      return state
  }
}
